import PbTwitterTokenGet from '../pb/webauthtwitterrequesttokenpro.pb';
import {userService} from "../request";

let getRequestToken = () => {
    let baseUrl = Uplib.url.delQuery(location.href, 'oauth_token');
    
    baseUrl = Uplib.url.delQuery(baseUrl, 'oauth_verifier');

    userService('/webauth/twitter/requesttoken/pro', PbTwitterTokenGet.WebAuth.TwitterRequestTokenPro)({
        callback: encodeURIComponent(baseUrl)
    }).then((resp) => {
        $('#wrap').empty();
        return resp;
    }).done(data => {
        $.channel.emit('getTwitterOauthTokenSuccess', data);
    }).catch(() => {
        Uplib.notification.simple('request fail');
    });
};

export default {
    getRequestToken
};



// WEBPACK FOOTER //
// ./src/js/openjs/deps/login/sns/twitter.js